import { LinearProgress } from '@mui/material';

import { Modal } from 'components/DesignSystem/Modal';

import classes from './ExportProgressModal.module.scss';

interface Props {
    isOpen: boolean;
    progress: number;
    exportType?: 'pdf' | 'pptx';
}

export const ExportProgressModal = ({ isOpen, progress, exportType = 'pptx' }: Props) => {
    const title = exportType === 'pdf' ? 'Exporting to PDF' : 'Exporting to PowerPoint';

    return (
        <Modal open={isOpen} disableEscapeKeyDown showCloseButton={false} title={title} width={400}>
            <div className={classes.progressContainer}>
                <div className={classes.progressBarWrapper}>
                    <LinearProgress
                        variant={'determinate'}
                        value={progress}
                        sx={{
                            height: 8,
                            borderRadius: 4,
                            backgroundColor: 'var(--border-tertiary)',
                            '& .MuiLinearProgress-bar': {
                                backgroundColor: 'var(--border-brand)',
                            },
                        }}
                    />
                </div>
                <div className={classes.percentageText}>{Math.round(progress)}%</div>
            </div>
        </Modal>
    );
};
